<template>
    <tapTop />
    <div class="page-wrapper " :class="display ? 'compact-sidebar compact-small material-icon' : layoutobj"
        id="pageWrapper">
        <div class="page-header" :class="{ close_icon: !store.togglesidebar }">
            <Header @clicked="sidebar_toggle" />
        </div>
        <div class="page-body-wrapper">
            <div class="sidebar-wrapper " :data-layout="storeLayout.svg == 'stroke-svg' ? 'stroke-svg' : 'fill-svg'"
                :class="[{ close_icon: !store.togglesidebar }, { 'sidebar-default': store.perentName }]">
                <Sidebar @clicked="sidebar_toggle" />
            </div>
            <div class="page-body">
                <div class="container-fluid"></div>
                <transition name="fadeIn" enter-active-class="animated fadeIn">
                    <router-view></router-view>
                </transition>
            </div>
            <footerView />
        </div>
    </div>
    <customizer />
</template>
<script lang="ts" setup>
const Header = defineAsyncComponent(() => import("@/components/commen/block/header/headerSection.vue"))
const Sidebar = defineAsyncComponent(() => import("@/components/commen/block/sidebar/sidebarSection.vue"))
const footerView = defineAsyncComponent(() => import("@/layout/footerView.vue"))
const tapTop = defineAsyncComponent(() => import("@/layout/tapTop.vue"))
const customizer = defineAsyncComponent(() => import("@/components/commen/block/customizer/indexCustomizer.vue"))
import { useMenuStore } from "@/store/menu";
import { uselayoutStore } from "@/store/layout";
import { storeToRefs } from "pinia";
import { ref, defineAsyncComponent, watch, onMounted } from 'vue'
const layoutobj = ref<any>({});
const sidebar_toggle_var = ref<boolean>(false);
const display = ref<boolean>(false)
const toggle = ref<boolean>(false)
const store = useMenuStore();
const storeLayout = uselayoutStore();
const { layout: layout } = storeToRefs(storeLayout);
watch(
    () => layout,
    () => {
        layoutobj.value = storeLayout.layout.settings.sidebar_setting;
    },
    { deep: true },
);
watch(
    () => "router",
    () => {

        if ((window.innerWidth < 991 && storeLayout.layout.settings.layout === 'Horizontal')) {
            const newlayout = JSON.parse(JSON.stringify(layoutobj).replace('horizontal-wrapper', 'compact-sidebar compact-small material-icon'));
            layoutobj.value = JSON.parse(JSON.stringify(newlayout))[storeLayout.layout.settings.layout];
        } else {
            layoutobj.value = JSON.parse(JSON.stringify(layoutobj))[storeLayout.layout.settings.layout];
        }
    }
)
function sidebar_toggle(value: boolean) {
    sidebar_toggle_var.value = !value;
}
function handleScroll() {
    if (window.innerWidth <= 1199) {
        display.value = true;
        store.togglesidebar = false

    } else {
        store.togglesidebar = true
        display.value = false;
    }
}
onMounted(() => {

    window.addEventListener('resize', handleScroll);
    layoutobj.value = storeLayout.layout.settings.sidebar_setting;

});
</script>